import { connect } from 'react-redux';

import LoadingStateProvider from '../../../components/LoadingStateProvider';

const mapStateToProps = ({ versionData: { isLoading, error } }) => {
  return { isLoading, error };
};

export default connect(mapStateToProps)(LoadingStateProvider);
